ActionPopup = {
  show: function(title, items, overlayId) {
    var overlay = document.createElement('div');
    overlay.id = overlayId || 'action-popup-overlay';
    overlay.style.cssText = 'position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,0.4);z-index:9999;display:flex;align-items:center;justify-content:center;';

    var dialog = document.createElement('div');
    dialog.style.cssText = 'background:white;padding:25px;border-radius:6px;box-shadow:0 4px 20px rgba(0,0,0,0.3);min-width:350px;text-align:center;';

    var html = '<h3 style="margin:0 0 15px 0;">' + title + '</h3>';
    html += '<div style="display:flex;flex-direction:column;gap:10px;">';

    var lastGroup = null;
    items.forEach(function(item) {
      if (item.group && item.group !== lastGroup && lastGroup !== null) {
        html += '<hr style="border:none;border-top:1px solid #eee;margin:5px 0;">';
      }
      lastGroup = item.group || null;
      // Optional item.method ("patch", "post", ...) rides rails-ujs data-method, so a
      // popup choice can hit a non-GET member action with the CSRF token.
      var methodAttribute = item.method ? ' data-method="' + item.method + '"' : '';
      html += '<a href="' + item.url + '" class="button"' + methodAttribute + ' style="text-decoration:none;padding:10px 15px;">' + item.label + '</a>';
    });

    html += '<a href="#" onclick="ActionPopup.close(\'' + (overlayId || 'action-popup-overlay') + '\'); return false;" style="color:#888;margin-top:5px;">Cancel</a>';
    html += '</div>';

    dialog.innerHTML = html;
    overlay.appendChild(dialog);
    document.body.appendChild(overlay);

    overlay.addEventListener('click', function(e) {
      if (e.target === overlay) ActionPopup.close(overlay.id);
    });
  },

  close: function(overlayId) {
    var overlay = document.getElementById(overlayId || 'action-popup-overlay');
    if (overlay) overlay.remove();
  }
};
